import React, { useState, useEffect } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import Loader from "../../components/Loader";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Box, Container, CardMedia, Card, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GetDashboardIDUrl, GetLoadDashboardUrl } from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "../../components/toast";
import { axiosGet } from "../../utils/Axios";
import { HeaderBlock } from "@colliers/colliers-b2c";


const LoadDashboard = () => {
  const { ToastComponent, showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
    const [dashboardID] = useState(location.state?.dashboardID || null);
    const [randomCodeState] = useState(location.state?.randomCode || null);
    const [reportConfig, setReportConfig] = useState(null);
    const [isDefault, setIsDefault] = useState(0);

    const { t } = useTranslation();

    useEffect(() => {
        const urlParams = location.pathname;
        console.log('urlParams', urlParams);

        const codeMatch = urlParams.match(/\/code=([A-Za-z0-9-]+)/);
        if (codeMatch) {
            const randomCode = codeMatch[1];
            console.log('randomCode', randomCode);

        getDashboardLoad(randomCode);
    } else if (randomCodeState) {
      const userInfo = localStorage.getItem("userInfo");
      if (!userInfo) {
        window.location.href = "/Login/KeyStone_Login";
        return;
      } else {
          getDashboardLoad(randomCodeState);
      }
    } else if (dashboardID) {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) {
            window.location.href = "/Login/KeyStone_Login";
            return;
        } else {
            setIsDefault(1);
            showToast("error", t("InvalidReportData", "Invalid data received."));
        }
    }
    }, [randomCodeState, navigate]);


    const getDashboardLoad = async (dashboardID) => {
        const endpoint = `?id=${dashboardID}`;
    setIsLoading(true);

        try {
            const response = await axiosGet(`${GetLoadDashboardUrl}${endpoint}`);
            debugger;
            if (response.message != undefined && response.message == "InActive") {
                setIsDefault(2);
                showToast("error", t("InActiveDasboard", "Dashboard is InActive."));
        }
        else if (response.message != undefined && response.message == "Invalid") {
            setIsDefault(1);
            showToast("error", t("InvalidReportData", "Invalid report data received."));
        }
        else if (response.message != undefined && response.message == "Access") {
            navigate('/access-denied')
            return
        }
        else {
            const isReportType = response?.Type === "Report";
            const hasEmbedReport = Array.isArray(response?.EmbedReport) && response.EmbedReport.length > 0;
            const hasEmbedToken = response?.EmbedToken?.Token;
            if (isReportType && hasEmbedReport && hasEmbedToken) {
                setIsDefault(0);
                const report = response.EmbedReport[0];
                setReportConfig({
                    type: "report",
                    embedUrl: report.EmbedUrl,
                    accessToken: response.EmbedToken.Token,
                    id: report.ReportId,
                    tokenType: models.TokenType.Embed,
                    settings: {
                        panes: {
                            filters: { expanded: false, visible: true },
                        },
                        background: models.BackgroundType.Default,
                        bars: {
                            actionBar: {
                                visible: true
                            }
                        }
                    },
                });

                }
                else {
                    setIsDefault(1);
                    showToast("error", t("InvalidReportData", "Invalid report data received."));
                console.error("Invalid response data:", response);
            }
        }
    } catch (error) {
      const errorMessage = error?.message || "Unknown error occurred";
      console.error("Error fetching dashboard data:", error);
      showToast("error", t("FetchError", `Error fetching dashboard details: ${errorMessage}`));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : <></>}
      <Box
              id="main"
              className="loadDashMain"
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            p: 0,
            width: "100%",
            height: "100%", // Full height
            display: "flex",
            flexDirection: "column",
          }}
        >
                  {reportConfig && isDefault===0 ? (
                      <PowerBIEmbed
                          embedConfig={reportConfig}
                          cssClassName="power-bi-report-class powerBIEmbed"
                      />
                  ) : isDefault > 0 && (
                          <Box
                              sx={{
                                  textAlign: "center",
                                  mt: 4,
                                  flex: 1,
                                  height: "100%",
                              }}
                          >
                                  <img src='/imgs/PowerBI.png' alt="Power BI" />
                              <Typography
                                  variant="h6"
                                  component="p"
                                  sx={{
                                      fontWeight: "bold",
                                      fontSize: "1rem",
                                      mb: 1,
                                      textAlign: "center",
                                      flex: 1,
                                      wordWrap: "break-word",
                                      cursor: "pointer"
                                  }}
                                  >
                                      {isDefault === 1 ? 'No report available to display.' : 'Dashboard is Inactive'}
                              </Typography>
                          </Box>
                  )
                  }
        </Container>
      </Box>
      {ToastComponent}
    </>
  );
};

export default LoadDashboard;